import request from '@/utils/request'

let MaterialApi = {
  /*素材列表*/
  materialList(data, errorback) {
    return request._post('/shop/plus.material3.material/index', data, errorback);
  },
  /*添加素材*/
  toAddMaterial(data, errorback) {
    return request._get('/shop/plus.material3.material/add', data, errorback);
  },
  /*素材添加*/
  materialAdd(data, errorback) {
    return request._post('/shop/plus.material3.material/add', data, errorback);
  },
  /*编辑素材*/
  toEditMaterial(data, errorback) {
    return request._get('/shop/plus.material3.material/edit', data, errorback);
  },
  /*素材编辑*/
  materialEdit(data, errorback) {
    return request._post('/shop/plus.material3.material/edit', data, errorback);
  },
  /*素材删除*/
  materialDel(data, errorback) {
    return request._post('/shop/plus.material3.material/delete', data, errorback);
  },
}
export default MaterialApi;



// WEBPACK FOOTER //
// ./src/api/material3.js